import { render } from "./App.vue?vue&type=template&id=72434b72"
const script = {}

import "./App.vue?vue&type=style&index=0&id=72434b72&lang=css"

import exportComponent from "/home/forge/obs.etr.audio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__